const trackingUrl = process.env.GATSBY_TRACKING_URL || 'https://staging.1pt.ownup.com/api/events';

interface RedirectType {
  from: string;
  to: string;
  status: number;
  force?: boolean;
}

export const redirects: RedirectType[] = [
  { from: '/events', to: `${trackingUrl}`, status: 200 },
  { from: '/*', to: '/learn/:splat/', status: 200 }
];
